import CallToAction from "components/CallToAction"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function InlineCTABanner({ blok }) {
  return (
    <div className="inline-cta-banner flex flex-col lg:flex-row justify-between py-6">
      {blok?.heading ? <h2 className="mb-4 lg:mb-0 basis-2/3">{blok.heading}</h2> : null}
      {blok?.button_label ? (
        <CallToAction
          href={getStoryblokLink(blok.button_link)}
          style="primary"
          className="whitespace-nowrap lg:self-center"
        >
          {blok.button_label}
        </CallToAction>
      ) : null}
    </div>
  )
}
